import _objectAssign from './_objectAssign.js';

var _assign = typeof Object.assign === 'function' ? Object.assign : _objectAssign;

export { _assign as default };
